import { Group, Radio, Stack, Text, Textarea } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useAmlFormContext } from '../types/types';

export function AdditionalInfoStep() {
  const { t } = useTranslation();
  const form = useAmlFormContext();

  return (
    <Stack gap="md" mt="md">
      <Textarea
        required
        label={t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.RELATION_ORIGIN)}
        placeholder={t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PLACEHOLDERS.RELATION_ORIGIN)}
        autosize
        minRows={3}
        {...form.getInputProps('relationOrigin')}
      />
      <Stack gap={4}>
        <Textarea
          required
          label={t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.SERVICE_DESCRIPTION)}
          placeholder={t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PLACEHOLDERS.SERVICE_DESCRIPTION)}
          autosize
          minRows={3}
          {...form.getInputProps('serviceDescription')}
        />
        <Text size="xs" c="dimmed">
          {t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.SERVICE_DESCRIPTION_HINT)}
        </Text>
      </Stack>
      <Stack gap="xs">
        <Text size="sm" fw={500}>
          {t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PEP_TITLE)}
        </Text>
        <Text size="xs" c="dimmed">
          {t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PEP_DESCRIPTION)}
        </Text>
        <Radio.Group {...form.getInputProps('pep')}>
          <Group gap="md">
            <Radio value="false" label={t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PEP_NO)} />
            <Radio value="true" label={t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PEP_YES)} />
          </Group>
        </Radio.Group>
        {form.values.pep === 'true' && (
          <Stack gap="xs" mt="xs">
            <Text size="sm" fw={500}>
              {t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PEP_DETAILS_LABEL)}
            </Text>
            <Textarea
              required
              placeholder={t(i18nKeys.AML_MODAL.ADDITIONAL_INFO.PEP_DETAILS_PLACEHOLDER)}
              autosize
              minRows={4}
              {...form.getInputProps('pepDetails')}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
